<script lang="ts">
const heightRef = 60
const heightBorderRef = 10
</script>
<template>
  <div ref="element" :style="styleOpacityAndHeight" class="background">
    <span class="top"></span>
    <span class="center" :style="styleCenter"></span>
    <span class="bottom" :style="styleBottom"></span>
  </div>
</template>
<script setup lang="ts">
// @ts-ignore
import { spring } from 'vue3-spring';
interface Props {
  height: number;
  color?: string;
  damping?: number;
  stiffness?: number;
  mass?: number;
}

const props = defineProps({
  height: null,
  color: null,
  damping: { default: 10 },
  stiffness: { default: 120 },
  mass: { default: 0.96 }
});

const emit = defineEmits(["updateHeight"]);

const element = ref<HTMLElement>(null);
const { $colors } = useNuxtApp();


const heightUsed = ref<number>(0);
const heightSpring = spring(heightUsed, {
  damping: props.damping,
  stiffness: props.stiffness,
  mass: props.mass,
  from: props.height,
});

const styleCenter = computed(() => {
  const centerRefHeight = heightRef - heightBorderRef * 2;
  const newCenterHeight = heightSpring.value - heightBorderRef * 2;
  const scale = newCenterHeight / centerRefHeight;
  return {
    transform: `scaleY(${scale})`,
  };
});
const styleBottom = computed(() => {
  const y = heightSpring.value - heightBorderRef;
  return {
    transform: `translateY(${y}px)`,
  };
});
const styleOpacityAndHeight = computed(() => {
  const diff = Math.min(heightSpring.value, heightRef);
  const opacity = diff / heightRef;
  return {
    opacity,
    height: `${heightSpring.value}px`,
  };
});

const csscolor = computed(() =>
  props.color ? props.color : $colors.secondary_dark
);

watchEffect(() => {
  heightUsed.value = props.height;
});
watchEffect(() => {
  emit('updateHeight', heightSpring);
});
</script>
<style lang="scss" scoped>
.background {
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;

  .center {
    position: absolute;
    top: 10px;
    width: 100%;
    height: 40px;
    transform-origin: 0 0;
    background: v-bind(csscolor);
  }
  .bottom,
  .top {
    position: absolute;
    width: 100%;
    height: 20px;
    background: v-bind(csscolor);
  }
  .top {
    top: 0;
    border-radius: var(--stroke_radius_m) var(--stroke_radius_m) 0 0;
  }
  .bottom {
    top: -10px;
    border-radius: 0 0 var(--stroke_radius_m) var(--stroke_radius_m);
  }
}
</style>
